import './styles/ShibUserItem.scss';

import { RemoveRedEyeRounded } from '@mui/icons-material';
import { Fab, Grid } from '@mui/material';
import { ShibUser } from '@thro-types/users';

import { Link } from 'react-router-dom';

interface Props {
  user: ShibUser;
}

export function ShibUserItem({ user }: Props) {
  return (
    <Grid container className="shib-user">
      <Grid container>
        <Grid item xs={1} className="shib-user__id">
          {user.id}
        </Grid>
        <Grid item xs={3} className="shib-user__uid">
          {user.uid}
        </Grid>
        <Grid item xs={3} className="shib-user__email">
          {user.email}
        </Grid>
        <Grid item xs={2} className="shib-user__firstName">
          {user.firstName}
        </Grid>
        <Grid item xs={2} className="shib-user__lastName">
          {user.lastName}
        </Grid>
        <Grid item xs={1} className="shib-user__actions">
          <Link to={`/shib/users/${user.id}`}>
            <Fab size="small" className="action">
              <RemoveRedEyeRounded />
            </Fab>
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
}
